var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapVert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7737_71193",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7737_71193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.91675 11.0211V5.78914L5.03909 7.6668L4 6.64593L7.64594 3L11.2919 6.64593L10.2528 7.6668L8.37512 5.78914V11.0211H6.91675ZM12.0211 17.5837L8.37512 13.9378L9.41421 12.9169L11.2919 14.7946V9.56268H12.7502V14.7946L14.6279 12.9169L15.667 13.9378L12.0211 17.5837Z",
    fill: "#545B62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapVert);
export default __webpack_public_path__ + "static/media/swap_vert.0481f838535180cb39b7800487c470f2.svg";
export { ForwardRef as ReactComponent };